/**
 * formatLongDate("2026-03-30")           → "30th March 2026"
 * formatLongDate("2026-03-30T12:00:00Z") → "30th March 2026"
 * formatLongDate(null | "" | "garbage")  → "-"
 *
 * Single source of truth for the long-form ordinal date used on Company
 * Info cards (Date of Formation, etc.). Use this anywhere we render a
 * date-only field that the user reads naturally rather than computes from.
 */

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

const ordinalSuffix = (day) => {
  // 11th, 12th, 13th are the exceptions to the standard 1st/2nd/3rd rule.
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

export const formatLongDate = (value) => {
  if (!value) return '-';
  // Accept either a Date object or a string (ISO, date-only, or anything Date can parse).
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '-';

  // Use UTC components to avoid the off-by-one rollover that bites
  // YYYY-MM-DD inputs in negative timezones (input "2026-03-30" parses
  // as 2026-03-30T00:00:00Z, which becomes Mar 29 in local UTC-5).
  const day = d.getUTCDate();
  const month = MONTHS[d.getUTCMonth()];
  const year = d.getUTCFullYear();
  return `${day}${ordinalSuffix(day)} ${month} ${year}`;
};

export default formatLongDate;
